module.exports = ["toEnglish","toEdition"]


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/langs.json
// module id = 826
// module chunks = 0